import { ACCOUNT_TYPE, LOGIN_TYPE } from '@/constant/common'
import Index from './index.vue'
import Login from './login.vue'
import CandidateRegister from './register/candidate.vue'
import EmployeeRegister from './register/employee.vue'
import ForgetPassword from './forgetPassword.vue'
import ResetPassword from './resetPassword.vue'
import CreatePassword from './createPassword.vue'
import ThirdParty from './thirdPartyLogin.vue'

const basePath = '/passport'

export const resetPasswordRoute = {
  path: `${basePath}/:accountType/reset-password/:code*`,
  component: ResetPassword,
  meta: {
    titleI18nKey: 'login.common.title.resetPassword'
  }
}

export const createPasswordRoute = {
  path: `${basePath}/:accountType/create-password/:code`,
  component: CreatePassword,
  meta: {
    titleI18nKey: 'login.common.title.createPassword'
  }
}

export const loginRoute = {
  path: `${basePath}/:accountType/login`,
  component: Login,
  meta: {
    titleI18nKey: 'login.common.title.login',
    loginType: LOGIN_TYPE.PASSWORD_LOGIN
  }
}

export const registerCandidateRoute = {
  path: `${basePath}/${ACCOUNT_TYPE.CANDIDATE}/register`,
  component: CandidateRegister,
  meta: {
    titleI18nKey: 'login.common.title.register',
    accountType: ACCOUNT_TYPE.CANDIDATE,
    loginType: LOGIN_TYPE.REGISTER_LOGIN
  }
}

export const registerEmployeeRoute = {
  path: `${basePath}/${ACCOUNT_TYPE.EMPLOYEE}/register`,
  component: EmployeeRegister,
  meta: {
    titleI18nKey: 'login.common.title.register',
    accountType: ACCOUNT_TYPE.EMPLOYEE
  }
}

export const thirdPartyRoute = {
  path: `${basePath}/:accountType/:thirdPartyType/third-party`,
  component: ThirdParty,
  meta: {
    titleI18nKey: 'login.common.title.login'
  }
}

export const forgetPasswordRoute = {
  path: `${basePath}/:accountType/forget-password`,
  component: ForgetPassword,
  meta: {
    titleI18nKey: 'login.common.title.forgetPassword'
  }
}

export default {
  path: basePath,
  redirect: `${basePath}/${ACCOUNT_TYPE.CANDIDATE}/login`,
  component: Index,
  meta: {
    noAuth: true
  },
  children: [
    loginRoute,
    registerCandidateRoute,
    registerEmployeeRoute,
    thirdPartyRoute,
    forgetPasswordRoute,
    resetPasswordRoute,
    createPasswordRoute
  ]
}
